import { Link, useParams } from 'react-router-dom'

import { OrganizationSetup } from './organization-setup'
import { PHONE_PATH, useOrganizationName } from './shared'

export const PhoneSetupDetail = () => {
  const { orgId = '' } = useParams()
  const organizationName = useOrganizationName(orgId)

  return (
    <div className="max-w-3xl space-y-6 text-primary">
      <Link className="text-sm underline" to={PHONE_PATH}>
        Back to phone setups
      </Link>
      <div className="space-y-1">
        <h1 className="text-2xl font-semibold">
          {organizationName ?? `Organization ${orgId}`}
        </h1>
        <p className="text-sm text-muted-foreground">Organization ID {orgId}</p>
      </div>
      <OrganizationSetup orgId={orgId} withStatus />
    </div>
  )
}
